import styled from 'styled-components'
import { Column } from 'components/common/layout'
import { BaseText, H5Text } from 'components/common/text'
import { ChipWrapper } from 'components/common/chip'
import { Card } from 'components/common/card'

export const DashboardPositionFormSection = styled(Column)`
  gap: 20px;
`

export const DashboardPositionFormSectionTitle = styled(H5Text)`
  font-weight: ${(p) => p.theme.fontWeight.semiBold};
`

export const DashboardPositionFormChipCard = styled(ChipWrapper)`
  padding: 12px 16px;
  background-color: ${(p) => p.theme.color.white1};
  border-radius: 16px;
`

export const DashboardPositionFormContentCard = styled(Card)`
  gap: 24px;
  padding: 16px;
`

export const DashboardPositionFormAlertText = styled(BaseText)`
  color: ${(p) => p.theme.color.alert};
  text-align: right;
  @media ${(p) => p.theme.deviceSize.mobile} {
    font-size: ${(p) => p.theme.fontSize.small};
  }
`
